import { Component } from '@angular/core';
import { SurveyConfigService } from '../../services/survey-config.service';

@Component({
    selector: 'app-users-panel-container',
    templateUrl: './users-panel-container.component.html',
    styleUrls: ['./users-panel-container.component.scss'],
    standalone: false
})
export class UsersPanelContainerComponent {

  constructor(public surveyConfig: SurveyConfigService) {

    console.log('UsersPanelContainerComponent constructor called');
  }

}
